import { MarketBaseLocalized } from './../objects/marketView';
import { Column } from "../objects/column";
import { MarketAll, MarketBase, MarketByClient, MarketType, MarketViewErrors } from "../objects/marketView";
import { MarketViewListConfiguration, MarketViewListCriteria, MarketViewListFiltersCriteria } from "../objects/marketViewList";

export const EMPTY_MARKET_VIEW_LOCALIZED: MarketBaseLocalized = {
    title: '',
    locale: 0,
};

export const EMPTY_MARKET_ALL: MarketViewErrors & MarketBase & MarketAll = {
    name: '',
    name_localized: {},
    is_active: true,
    type: MarketType.ALL,
    details: {
        continents: [],
        countries: [],
        clients: []
    }
};
export const EMPTY_MARKET_CLIENT: MarketViewErrors & MarketBase & MarketByClient = {
    name: '',
    name_localized: {},
    type: MarketType.CLIENT,
    is_active: true,
    details: {
        continents: [],
        countries: [],
        clients: []
    }
};

export const MARKET_VIEW_MODULE = 'MARKET_VIEW_MODULE';


export const MARKET_COLUMN: Column[] = [
    {
        label: 'name',
        field_name: 'NAME',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'type',
        field_name: 'TYPE',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }
];

export const EMPTY_MARKET_VIEW_FILTERS: MarketViewListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
};


export const EMPTY_MARKET_VIEW_LIST_CRITERIA: MarketViewListCriteria = {
    limit: 50,
    page: 0,
    order_by: 'modified_date',
    order: 'desc',
    filters: EMPTY_MARKET_VIEW_FILTERS,
    search: '',
    target_client__in: [],
    client_branch: null
};

export const EMPTY_MARKET_VIEW_LIST_CONFIGURATION: MarketViewListConfiguration = {
    columns: MARKET_COLUMN,
    preferences: []
};
